<template>
  <FreeBottomSheet :name="name" @onClose="slideMoved = false">
    <template #header="{ hide }">
      <FreeHeader class="p-4">
        <template #default>
          <h3 class="text-base font-medium">{{ t('title') }}</h3>
        </template>
        <template #rightAction>
          <FreeCloseButton @click="hide" />
        </template>
      </FreeHeader>
    </template>
    <template #default>
      <div class="space-y-4 px-4 pb-4">
        <FreeCarouselLegacy
          ref="documentsCarousel"
          :carousel-config="{
            peek: 0,
            rewind: false,
          }"
          @onActiveSlideChange.once="slideMoved = true"
        >
          <template #default>
            <FreeCarouselItemLegacy>
              <DocumentInfo
                :title="t('passport.title')"
                :message="t('passport.description')"
              >
                <template #image>
                  <img
                    v-if="theme === 'dark'"
                    src="../../../assets/images/documents/passport-dark.webp"
                    width="212"
                    height="120"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../../assets/images/documents/passport.webp"
                    width="212"
                    height="120"
                    alt=""
                  />
                </template>
              </DocumentInfo>
            </FreeCarouselItemLegacy>
            <FreeCarouselItemLegacy>
              <DocumentInfo
                :title="t('id.title')"
                :message="t('id.description')"
              >
                <template #image>
                  <img
                    v-if="theme === 'dark'"
                    src="../../../assets/images/documents/identification-dark.webp"
                    width="212"
                    height="120"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../../assets/images/documents/identification.webp"
                    width="212"
                    height="120"
                    alt=""
                  />
                </template>
              </DocumentInfo>
            </FreeCarouselItemLegacy>
          </template>
          <template #bullets>
            <FreeBulletsLegacy />
          </template>
        </FreeCarouselLegacy>
        <FreeButton class="gray-button w-full" @click="onButtonClick">
          {{ mainBtnText }}
          <img
            v-if="!slideMoved"
            class="ml-2"
            src="../../../assets/images/chevron-arrow.svg"
            width="24"
            height="24"
            alt=""
          />
        </FreeButton>
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { ref, computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { controllerModel } from 'shared';

  import {
    FreeCloseButton,
    FreeHeader,
    FreeBottomSheet,
    FreeCarouselLegacy,
    FreeCarouselItemLegacy,
    FreeBulletsLegacy,
    FreeButton,
  } from '../../../shared/ui';
  import DocumentInfo from './DocumentInfo.vue';

  const props = defineProps<{
    name: string;
  }>();

  const { t } = useI18n();

  const bottomSheet = controllerModel.useBottomSheet();
  const documentsCarousel = ref<InstanceType<typeof FreeCarouselLegacy> | null>(
    null,
  );
  const goToPassportSlide = () => documentsCarousel.value?.glider.go('>');
  const slideMoved = ref(false);
  const onButtonClick = () => {
    if (slideMoved.value) {
      bottomSheet.hide(props.name);
    } else {
      goToPassportSlide();
    }
  };
  const mainBtnText = computed(() =>
    slideMoved.value ? t('close') : t('id.title'),
  );

  const theme = localStorage.getItem('theme') || 'light';
</script>

<i18n src="../locales.json"></i18n>
